import { render, staticRenderFns } from "./adminPage.vue?vue&type=template&id=6944a5f7&scoped=true&"
import script from "./adminPage.vue?vue&type=script&lang=js&"
export * from "./adminPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6944a5f7",
  null
  
)

export default component.exports